var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVCutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.599 27C18.6745 30.3333 13.8633 30.3333 11.9388 27L0.680457 7.5C-1.24404 4.16667 1.16158 -3.06206e-06 5.01058 -2.72557e-06L27.5272 -7.57104e-07C31.3762 -4.20613e-07 33.7819 4.16667 31.8574 7.5L20.599 27Z",
    fill: "#D2042D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVCutIcon);
export default __webpack_public_path__ + "static/media/v-cut-icon.267f54a19a01a2c991a6a42a5a4dd286.svg";
export { ForwardRef as ReactComponent };